import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

const BoolIcon = ({ classes, bool }) => {
  if (bool === true || bool === false) {
    return (
      <div className={classes.container}>
        {bool ? <CheckIcon /> : <CloseIcon />}
      </div>
    )
  }
  return null;
}

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    color: 'rgba(0, 0, 0, 0.65)'
  }
});

export default withStyles(styles)(BoolIcon);